import type {ReactNode} from 'react';

import {cn} from '@/utils/ui';

export type TableListViewProps = {
  children: ReactNode;
  className?: string;
};
const TableListView = ({children, className}: TableListViewProps) => {
  return <div className={cn('flex flex-col', className)}>{children}</div>;
};

export default TableListView;
